import { ComponentType, FC, ReactNode } from "react";
import cx from "classnames";
import style from "./Card.module.scss";
import { Parallax } from "react-parallax";

export const CardTestProps: CardProps = {
  description:
    "Какие средства избавят вас от процедур в автосервисе: инструкция",
  title: "Промывка инжектора и форсунок: это легко!",
  content: (
    <Parallax bgImage={"./images/img.png"} strength={-25}>
      <div style={{ height: "253px" }}></div>
    </Parallax>
  ),
};

export type CardProps = {
  big?: boolean;

  className?: string;
} & CardCoreProps;
export const VideoCard: FC<CardProps> = ({
 
  className,
  ...rest
}) => {
  return (
    <div className={cx(style.card, style["video-card"], className)}>
      <CardCore {...rest} />
    </div>
  );
};

type CardCoreProps = {
  description: string;
  title: string;
  content: ReactNode;
  titleAsHtml?: boolean;
};
export const CardCore: FC<CardCoreProps> = ({
  content,
  title,
  description,
  titleAsHtml,
}) => {
  const titleElement = titleAsHtml ? (
    <div className={"title"} dangerouslySetInnerHTML={{ __html: title }}></div>
  ) : (
    <div className={"title"}>{title}</div>
  );

  return (
    <div className={style["card-core"]}>
      <div className={style.img}>{content}</div>
      <div className={style.content}>
        {titleElement}
        <div className={"desc"}>{description}</div>
      </div>
    </div>
  );
};
